import type { RouteDefinition } from "../route-definition.ts";

export const adminPoliciesRoutes = {
  "admin.policyPerformance": {
    path: "/admin/policies/:policyId/performance",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.policyVersions": {
    path: "/admin/policies/:policyId/versions",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.policyActivity": {
    path: "/admin/policies/:policyId/activity",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.policyVersionNested": {
    path: "/admin/policies/:policyId/versions/:policyVersionId",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.policyVersionEpisodes": {
    path: "/admin/policies/:policyId/versions/:policyVersionId/episodes",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.policyVersionComparisons": {
    path: "/admin/policies/:policyId/versions/:policyVersionId/comparisons",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.policyVersionAccess": {
    path: "/admin/policies/:policyId/versions/:policyVersionId/access",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.policyVersionDiagnostics": {
    path: "/admin/policies/:policyId/versions/:policyVersionId/diagnostics",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.policyVersionActivity": {
    path: "/admin/policies/:policyId/versions/:policyVersionId/activity",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.policies": {
    path: "/admin/policies",
    scope: "static",
    bucket: "admin",
    entry: "nav",
    disposition: "page",
  },
  "admin.policy": {
    path: "/admin/policies/:policyId",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.policyVersion": {
    path: "/admin/policies/versions/:policyVersionId",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.checks": {
    path: "/admin/policies/versions/:policyVersionId/checks",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
} as const satisfies Record<string, RouteDefinition>;
